$(document).ready(function () {
    $('#sap').click(function () {
        $('#sap-form').submit();
    });
});
